import React, { useState, useEffect } from 'react';
import './TableList.css';
import AthleteFormModal from './AthletesFormModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPen } from '@fortawesome/free-solid-svg-icons';

export default function Athletes() {
    const [athletes, setAthletes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedId, setSelectedId] = useState(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('name-az');

    // Fetch athletes list
    const fetchAthletes = () => {
        setLoading(true);
        const token = localStorage.getItem('jwtToken');

        fetch('https://www.fro.ro/api/athletes/index.php', {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setAthletes(data.data);
                } else {
                    setError('Eroare la încărcarea sportivilor');
                }
                setLoading(false);
            })
            .catch(() => {
                setError('Eroare la conexiune');
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchAthletes();
    }, []);

    // Delete athlete
    const handleDelete = (athleteId) => {
        if (!window.confirm('Sigur dorești să ștergi acest sportiv?')) return;

        const token = localStorage.getItem('jwtToken');
        const backendUrl = 'https://www.fro.ro/api/athletes/delete.php';

        fetch(`${backendUrl}?id=${athleteId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(res => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then(data => {
                if (data.success) {
                    alert('Sportiv șters cu succes!');
                    fetchAthletes();
                } else {
                    alert('Eroare la ștergere: ' + data.message);
                }
            })
            .catch(error => {
                alert('Eroare la conexiune: ' + error.message);
            });
    };

    // Edit athlete
    const handleEdit = (athlete) => {
        alert('Editează sportivul: ' + athlete.name);
        // Deschide modal/form pentru editare
    };

    const filteredAthletes = athletes.filter(a =>
        a.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sortedAthletes = [...filteredAthletes].sort((a, b) => {
        if (sortBy === 'name-az') {
            return a.name.localeCompare(b.name);
        } else if (sortBy === 'club-az') {
            return a.club.localeCompare(b.club);
        } else if (sortBy === 'age') {
            return a.age - b.age;
        }
        return 0;
    });

    if (loading) return <p>Se încarcă sportivii...</p>;
    if (error) return <p style={{ color: 'red' }}>{error}</p>;

    return (
        <div className="table-list-container">
            <div className="table-list-header">
                <div className="sort-bar">
                    <label htmlFor="sort-select" className="sort-label">Sort by:</label>
                    <select
                        id="sort-select"
                        className="sort-select"
                        value={sortBy}
                        onChange={e => setSortBy(e.target.value)}
                    >
                        <option value="name-az">A-Z by name</option>
                        <option value="club-az">A-Z by club</option>
                        <option value="age">Age</option>
                    </select>
                </div>
                <input
                    type="text"
                    className="search-bar"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                />
                <button
                    className="add-circle-btn"
                    onClick={() => setShowAddModal(true)}
                    aria-label="Adaugă sportiv"
                >
                    <span className="plus-icon">+</span>
                </button>
            </div>
            <table className="table-list">
                <thead>
                    <tr>
                        <th>Nr. legitimație</th>
                        <th>Nume</th>
                        <th>An naștere</th>
                        <th>CNP</th>
                        <th>Email</th>
                        <th>Telefon</th>
                        <th>Acțiuni</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedAthletes.length === 0 ? (
                        <tr>
                            <td colSpan={7}>Nu există sportivi.</td>
                        </tr>
                    ) : (
                        sortedAthletes.map(a => (
                            <tr
                                key={a.id}
                                className={selectedId === a.id ? 'selected' : ''}
                                onClick={() => setSelectedId(a.id)}
                                style={{ cursor: 'pointer' }}
                            >
                                <td>
                                    {a.nr_legitimatie && a.nr_legitimatie.trim() !== '' ? (
                                        <span className="badge-legitimatie">{a.nr_legitimatie}</span>
                                    ) : (
                                        <span className="badge-legitimatie empty">-</span>
                                    )}
                                </td>
                                <td>{a.first_name} {a.last_name}</td>
                                <td>{a.birth_year}</td>
                                <td>{a.cnp || '-'}</td>
                                <td>{a.email || '-'}</td>
                                <td>{a.phone || '-'}</td>
                                <td className="table-list-actions">
                                    <button
                                        className="action-btn edit"
                                        title="Editează"
                                        onClick={e => { e.stopPropagation(); handleEdit(a); }}
                                    >
                                        <FontAwesomeIcon icon={faPen} size="lg" color="#222" />
                                    </button>
                                    <button
                                        className="action-btn delete"
                                        title="Șterge"
                                        onClick={e => { e.stopPropagation(); handleDelete(a.id); }}
                                    >
                                        <FontAwesomeIcon icon={faTrash} size="lg" color="#fff" />
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>

            </table>
            {showAddModal && <AthleteFormModal onClose={() => setShowAddModal(false)} />}
        </div>
    );
}
